// Reserved system team ("master", formerly "creador").
// The master team is system-managed (soporte only): hidden from ALL displays,
// never assignable manually. Keep legacy "creador" in the reserved set so any
// unmigrated record is still hidden.

export const MASTER_TEAM = 'master';
export const LEGACY_MASTER_TEAM = 'creador';

export const RESERVED_TEAMS = new Set([MASTER_TEAM, LEGACY_MASTER_TEAM]);

export function isReservedTeam(key) {
  return typeof key === 'string' && RESERVED_TEAMS.has(key.trim());
}

export default { MASTER_TEAM, LEGACY_MASTER_TEAM, RESERVED_TEAMS, isReservedTeam };
